import { render, staticRenderFns } from "./SizeSelectorCommon.vue?vue&type=template&id=000058a6&scoped=true"
import script from "./SizeSelectorCommon.vue?vue&type=script&lang=js"
export * from "./SizeSelectorCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000058a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('000058a6')) {
      api.createRecord('000058a6', component.options)
    } else {
      api.reload('000058a6', component.options)
    }
    module.hot.accept("./SizeSelectorCommon.vue?vue&type=template&id=000058a6&scoped=true", function () {
      api.rerender('000058a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/shapeAttr/SizeSelectorCommon.vue"
export default component.exports